import { Outlet } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function SiteLayout() {
    return (
        <div className="min-h-screen bg-white text-neutral-950 flex flex-col vg-grain">
            <Nav />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
